import { atom } from "recoil";

export const readingProblemTypeAtom = atom<number>({
  key: "readingProblemTypeAtom",
  default: 0,
});
